export const ELEMENT_RESIZING_START = 'ELEMENT_RESIZING_START';
export const ELEMENT_RESIZING_END = 'ELEMENT_RESIZING_END';
export const ELEMENT_RESIZING_UPDATE_SCALE = 'ELEMENT_RESIZING_UPDATE_SCALE';
export const ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO = 'ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO';
export const ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES = 'ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES';

export const ELEMENT_RESIZE_INTERPOLATION_FACTOR = 0.3;
